//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { picFilter } from '@/assets/utils';
export default {
  name: 'V',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  computed: {
    productImage: function productImage() {
      return picFilter(this.rowData[this.fieldData['fieldCode']], {
        size: 'large'
      });
    }
  }
};